export const imageBaseUrl=`https://admin-apis.quizzzmaster.com`;